import { defineMessages } from 'react-intl';

export default defineMessages({
    thisSavesMe: {
        id: '_.draw_down.choose_amount.this_saves_me',
        defaultMessage: 'this saves you'
    }
});
